let rejectedAuthority: string | null = null;

export function markPrivateBetaWalletRejected(authority: string) {
	rejectedAuthority = authority;
}

export function clearPrivateBetaWalletRejected() {
	rejectedAuthority = null;
}

export function isPrivateBetaRejectedAuthority(authority: string) {
	return rejectedAuthority === authority;
}
